import { useState, useEffect } from 'react'
import api from '@/lib/api/axios'

// Cache the app type to avoid repeated API calls
let cachedAppType: 'scheduler' | 'orchestrator' | null = null
let fetchPromise: Promise<'scheduler' | 'orchestrator'> | null = null

// Function to clear cache (useful for testing/debugging)
export function clearAppTypeCache() {
    cachedAppType = null
    fetchPromise = null
}

export function useAppType() {
    const [appType, setAppType] = useState<'scheduler' | 'orchestrator'>('scheduler')
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        // Always fetch fresh data on mount (don't rely on cache)
        const fetchAppType = async () => {
            try {
                const response = await api.get('/api/app/config')
                const type = response?.data?.applicationType === 'orchestrator' ? 'orchestrator' : 'scheduler'
                console.log('✅ App type fetched from API:', type, response?.data)
                cachedAppType = type
                setAppType(type)
                setIsLoading(false)
            } catch (error: any) {
                // Log error for debugging
                console.error('❌ Failed to fetch app type:', error?.message || error, error?.response?.status, error?.code)
                // Use cached value if available, otherwise default to 'scheduler'
                const type = cachedAppType || 'scheduler'
                setAppType(type)
                setIsLoading(false)
            }
        }

        fetchAppType()
    }, [])

    return { appType, isLoading }
}

